// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { GetEntityDetails_Entity_DocumentFragment } from '../../../components/EntityNotesPerDeath/graphql/GetHouseholdDocuments.generated';
import { gql } from '@apollo/client';
import { GetEntityDetails_Entity_DocumentFragmentDoc } from '../../../components/EntityNotesPerDeath/graphql/GetHouseholdDocuments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEntityDetails_EntityFragment = { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string }, documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: (
        { __typename?: 'Document' }
        & GetEntityDetails_Entity_DocumentFragment
      ) | null } | null> | null }, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: (
          { __typename?: 'Document' }
          & GetEntityDetails_Entity_DocumentFragment
        ) } | null } | null> | null } };

export type GetEntityDetailsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type GetEntityDetailsQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & GetEntityDetails_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetEntityDetails: 'GetEntityDetails' as const
  },
  Fragment: {
    GetEntityDetails_Entity: 'GetEntityDetails_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetEntityDetails_EntityFragmentDoc = gql`
    fragment GetEntityDetails_Entity on Entity {
  id
  subtype {
    id
    displayName
  }
  documents {
    edges {
      node {
        ...GetEntityDetails_Entity_Document
      }
    }
  }
  entityDocumentRelationships {
    edges {
      node {
        id
        relationshipType
        document {
          ...GetEntityDetails_Entity_Document
        }
      }
    }
  }
}
    ${GetEntityDetails_Entity_DocumentFragmentDoc}`;
export const GetEntityDetailsDocument = gql`
    query GetEntityDetails($entityId: ID!) {
  entities(where: {id: $entityId}) {
    edges {
      node {
        ...GetEntityDetails_Entity
      }
    }
  }
}
    ${GetEntityDetails_EntityFragmentDoc}`;

/**
 * __useGetEntityDetailsQuery__
 *
 * To run a query within a React component, call `useGetEntityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityDetailsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEntityDetailsQuery, GetEntityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityDetailsQuery, GetEntityDetailsQueryVariables>(GetEntityDetailsDocument, withFetchPolicyContext(options));
      }
export function useGetEntityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityDetailsQuery, GetEntityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityDetailsQuery, GetEntityDetailsQueryVariables>(GetEntityDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetEntityDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEntityDetailsQuery, GetEntityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityDetailsQuery, GetEntityDetailsQueryVariables>(GetEntityDetailsDocument, withFetchPolicyContext(options));
        }
export type GetEntityDetailsQueryHookResult = ReturnType<typeof useGetEntityDetailsQuery>;
export type GetEntityDetailsLazyQueryHookResult = ReturnType<typeof useGetEntityDetailsLazyQuery>;
export type GetEntityDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEntityDetailsSuspenseQuery>;
export type GetEntityDetailsQueryResult = Apollo.QueryResult<GetEntityDetailsQuery, GetEntityDetailsQueryVariables>;